import React from 'react';
import { FormattedMessage } from 'react-intl';

const messages = [
    <FormattedMessage
        id="abt.sourcing.loggedOut.line1"
        defaultMessage="You need to be a member of our trade program to access this page."
    />,
    <FormattedMessage
        id="abt.sourcing.loggedOut.line2"
        defaultMessage="Are you an interior designer or architect?"
    />,
];

export default messages;
